import React  from "react";
import { useParams } from 'react-router-dom';
import HolidayForm from "./components/HolidayForm";
import Card from "components/card";

const EditHoliday = () => {

	const { holidayId } = useParams();

	return (
	    <div>
			<Card extra={"w-full h-full p-4"}>
				<div className="mt-5 grid h-full grid-cols-1 gap-4">
					<HolidayForm recordId={holidayId} mode="edit"/>
				</div>
			</Card>
	    </div>
    );
};

export default EditHoliday;